// import React, { useState, useEffect } from 'react';
// import { BarChart, Bar, LineChart, Line, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
// import { Users, Monitor, UserCheck, Image, FileText, MapPin, Smartphone, TrendingUp, Calendar } from 'lucide-react';

// const API_BASE = 'https://api.medstown.com/api/admin-controls/stats/graph';

// const COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6', '#f97316'];

// export default function UserGraph() {
//   const [period, setPeriod] = useState('thisMonth');
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [customDates, setCustomDates] = useState({ start: '', end: '' });

//   const periods = [
//     { value: 'today', label: 'Today' },
//     { value: 'yesterday', label: 'Yesterday' },
//     { value: 'thisWeek', label: 'This Week' },
//     { value: 'lastWeek', label: 'Last Week' },
//     { value: 'thisMonth', label: 'This Month' },
//     { value: 'lastMonth', label: 'Last Month' },
//     { value: 'thisYear', label: 'This Year' },
//     { value: 'overall', label: 'Overall' },
//     { value: 'custom', label: 'Custom' }
//   ];

//   useEffect(() => {
//     fetchData();
//   }, [period]);

//   const fetchData = async () => {
//     setLoading(true);
//     try {
//       let url = `${API_BASE}?period=${period}`;
//       if (period === 'custom' && customDates.start && customDates.end) {
//         url += `&start=${customDates.start}&end=${customDates.end}`;
//       }
//       const response = await fetch(url);
//       const result = await response.json();
//       setData(result.data);
//     } catch (error) {
//       console.error('Error fetching data:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatGraphData = (graphData) => {
//     if (!graphData) return [];
//     return graphData.map(item => ({
//       date: new Date(item.date).toLocaleString('en-US', {
//         month: 'short',
//         day: 'numeric',
//         hour: period === 'today' || period === 'yesterday' ? 'numeric' : undefined
//       }),
//       count: item.count
//     }));
//   };

//   const StatCard = ({ icon: Icon, title, value, color }) => (
//     <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3">
//       <div className="flex items-center justify-between">
//         <div className="flex-1">
//           <p className="text-xs text-gray-500 mb-0.5">{title}</p>
//           <p className="text-xl font-semibold text-gray-900">{value.toLocaleString()}</p>
//         </div>
//         <div className={`p-2 rounded-lg ${color}`}>
//           <Icon className="w-4 h-4 text-white" />
//         </div>
//       </div>
//     </div>
//   );

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-3"></div>
//           <p className="text-sm text-gray-600">Loading analytics...</p>
//         </div>
//       </div>
//     );
//   }

//   if (!data || !data.stats) return null;

//   const stats = data.stats;
//   const graphData = formatGraphData(data.graphData);

//   return (
//     <div className="min-h-screen bg-gray-50 p-4">
//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="mb-4">
//           <h1 className="text-2xl font-bold text-gray-900 mb-1">Analytics Dashboard</h1>
//           <p className="text-xs text-gray-500">User statistics and insights</p>
//         </div>

//         {/* Period Selector */}
//         <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3 mb-4">
//           <div className="flex flex-wrap gap-2 items-center">
//             <Calendar className="w-4 h-4 text-gray-400" />
//             {periods.map(p => (
//               <button
//                 key={p.value}
//                 onClick={() => setPeriod(p.value)}
//                 className={`px-3 py-1 text-xs font-medium rounded-md transition-colors ${
//                   period === p.value
//                     ? 'bg-blue-600 text-white'
//                     : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
//                 }`}
//               >
//                 {p.label}
//               </button>
//             ))}
//           </div>

//           {period === 'custom' && (
//             <div className="flex gap-2 mt-3 items-center">
//               <input
//                 type="date"
//                 value={customDates.start}
//                 onChange={(e) => setCustomDates({...customDates, start: e.target.value})}
//                 className="px-2 py-1 text-xs border border-gray-300 rounded-md"
//               />
//               <span className="text-xs text-gray-500">to</span>
//               <input
//                 type="date"
//                 value={customDates.end}
//                 onChange={(e) => setCustomDates({...customDates, end: e.target.value})}
//                 className="px-2 py-1 text-xs border border-gray-300 rounded-md"
//               />
//               <button
//                 onClick={fetchData}
//                 className="px-3 py-1 text-xs bg-blue-600 text-white rounded-md hover:bg-blue-700"
//               >
//                 Apply
//               </button>
//             </div>
//           )}
//         </div>

//         {/* Key Metrics */}
//         <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
//           <StatCard icon={Users} title="Total Users" value={stats.totalUsers} color="bg-blue-500" />
//           <StatCard icon={Image} title="With Profile Pic" value={stats.withProfilePic} color="bg-green-500" />
//           <StatCard icon={FileText} title="With Prescriptions" value={stats.withPrescriptions} color="bg-orange-500" />
//           <StatCard icon={UserCheck} title="With Patient Details" value={stats.withPatientDetails} color="bg-purple-500" />
//         </div>

//         {/* Growth Chart */}
//         <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-4">
//           <div className="flex items-center justify-between mb-3">
//             <h2 className="text-sm font-semibold text-gray-900">User Growth Trend</h2>
//             <TrendingUp className="w-4 h-4 text-blue-600" />
//           </div>
//           <ResponsiveContainer width="100%" height={200}>
//             <LineChart data={graphData}>
//               <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
//               <XAxis dataKey="date" tick={{fontSize: 10}} stroke="#9ca3af" />
//               <YAxis tick={{fontSize: 10}} stroke="#9ca3af" />
//               <Tooltip contentStyle={{fontSize: 11, padding: 8}} />
//               <Line type="monotone" dataKey="count" stroke="#3b82f6" strokeWidth={2} dot={{r: 3}} />
//             </LineChart>
//           </ResponsiveContainer>
//         </div>

//         {/* Platform & User Type Distribution */}
//         <div className="grid md:grid-cols-2 gap-4 mb-4">
//           <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
//             <div className="flex items-center gap-2 mb-3">
//               <Monitor className="w-4 h-4 text-gray-600" />
//               <h2 className="text-sm font-semibold text-gray-900">By Platform</h2>
//             </div>
//             <ResponsiveContainer width="100%" height={180}>
//               <PieChart>
//                 <Pie
//                   data={stats.byPlatform}
//                   dataKey="count"
//                   nameKey="_id"
//                   cx="50%"
//                   cy="50%"
//                   outerRadius={60}
//                   label={(entry) => `${entry._id}: ${entry.count}`}
//                   labelStyle={{fontSize: 10}}
//                 >
//                   {stats.byPlatform.map((entry, index) => (
//                     <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                   ))}
//                 </Pie>
//                 <Tooltip contentStyle={{fontSize: 11, padding: 6}} />
//               </PieChart>
//             </ResponsiveContainer>
//           </div>

//           <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
//             <div className="flex items-center gap-2 mb-3">
//               <UserCheck className="w-4 h-4 text-gray-600" />
//               <h2 className="text-sm font-semibold text-gray-900">By User Type</h2>
//             </div>
//             <ResponsiveContainer width="100%" height={180}>
//               <BarChart data={stats.byUserType}>
//                 <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
//                 <XAxis dataKey="_id" tick={{fontSize: 10}} stroke="#9ca3af" />
//                 <YAxis tick={{fontSize: 10}} stroke="#9ca3af" />
//                 <Tooltip contentStyle={{fontSize: 11, padding: 6}} />
//                 <Bar dataKey="count" fill="#10b981" radius={[4, 4, 0, 0]} />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </div>

//         {/* Top Regions & Cities */}
//         <div className="grid md:grid-cols-2 gap-4 mb-4">
//           <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
//             <div className="flex items-center gap-2 mb-3">
//               <MapPin className="w-4 h-4 text-gray-600" />
//               <h2 className="text-sm font-semibold text-gray-900">Top Regions</h2>
//             </div>
//             <div className="space-y-2">
//               {stats.byRegion.slice(0, 8).map((region, idx) => (
//                 <div key={idx} className="flex items-center justify-between">
//                   <span className="text-xs text-gray-700">{region._id || 'Unknown'}</span>
//                   <div className="flex items-center gap-2">
//                     <div className="w-24 bg-gray-200 rounded-full h-1.5">
//                       <div
//                         className="bg-blue-600 h-1.5 rounded-full"
//                         style={{width: `${(region.count / stats.byRegion[0].count) * 100}%`}}
//                       ></div>
//                     </div>
//                     <span className="text-xs font-medium text-gray-900 w-10 text-right">{region.count}</span>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
//             <div className="flex items-center gap-2 mb-3">
//               <MapPin className="w-4 h-4 text-gray-600" />
//               <h2 className="text-sm font-semibold text-gray-900">Top Cities</h2>
//             </div>
//             <div className="space-y-2">
//               {stats.byCity.slice(0, 8).map((city, idx) => (
//                 <div key={idx} className="flex items-center justify-between">
//                   <span className="text-xs text-gray-700">{city._id || 'Unknown'}</span>
//                   <div className="flex items-center gap-2">
//                     <div className="w-24 bg-gray-200 rounded-full h-1.5">
//                       <div
//                         className="bg-green-600 h-1.5 rounded-full"
//                         style={{width: `${(city.count / stats.byCity[0].count) * 100}%`}}
//                       ></div>
//                     </div>
//                     <span className="text-xs font-medium text-gray-900 w-10 text-right">{city.count}</span>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* App Versions */}
//         <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
//           <div className="flex items-center gap-2 mb-3">
//             <Smartphone className="w-4 h-4 text-gray-600" />
//             <h2 className="text-sm font-semibold text-gray-900">App Versions</h2>
//           </div>
//           <div className="grid md:grid-cols-2 gap-4">
//             {stats.byAppVersion.map((platform, idx) => (
//               <div key={idx}>
//                 <h3 className="text-xs font-medium text-gray-700 mb-2 uppercase">{platform.platform}</h3>
//                 <div className="space-y-1.5">
//                   {platform.versions.sort((a, b) => b.count - a.count).slice(0, 6).map((v, i) => (
//                     <div key={i} className="flex items-center justify-between text-xs">
//                       <span className="text-gray-600">v{v.version}</span>
//                       <span className="font-medium text-gray-900">{v.count} users</span>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import {
  Users,
  Monitor,
  UserCheck,
  Image,
  FileText,
  MapPin,
  Smartphone,
  TrendingUp,
  Calendar,
} from "lucide-react";

const API_BASE = "https://api.medstown.com/api/admin-controls/stats/graph";

const COLORS = [
  "#3b82f6",
  "#10b981",
  "#f59e0b",
  "#ef4444",
  "#8b5cf6",
  "#ec4899",
  "#14b8a6",
  "#f97316",
];

export default function AnalyticsDashboard() {
  const [period, setPeriod] = useState("thisMonth");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [customDates, setCustomDates] = useState({ start: "", end: "" });
  const [error, setError] = useState(null);

  const periods = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "thisWeek", label: "This Week" },
    { value: "lastWeek", label: "Last Week" },
    { value: "thisMonth", label: "This Month" },
    { value: "lastMonth", label: "Last Month" },
    { value: "thisYear", label: "This Year" },
    { value: "overall", label: "Overall" },
    // { value: 'custom', label: 'Custom' }
  ];

  useEffect(() => {
    fetchData();
  }, [period]);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      let url = `${API_BASE}?period=${period}`;
      if (period === "custom" && customDates.start && customDates.end) {
        url += `&start=${customDates.start}&end=${customDates.end}`;
      }
      const response = await fetch(url);
      const result = await response.json();

      console.log("API Response:", result);

      if (result.success) {
        setData(result.data);
      } else {
        setError("Failed to fetch data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const formatGraphData = (graphData) => {
    if (!graphData || !Array.isArray(graphData)) return [];
    return graphData.map((item) => ({
      date: new Date(item.date).toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        hour: ["today", "yesterday"].includes(period) ? "numeric" : undefined,
      }),
      count: item.count,
    }));
  };

  const StatCard = ({ icon: Icon, title, value, color }) => (
    <div className="rounded-lg border border-gray-200 bg-white p-3 shadow-sm">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="mb-0.5 text-xs text-gray-500">{title}</p>
          <p className="text-xl font-semibold text-gray-900">
            {value?.toLocaleString() || 0}
          </p>
        </div>
        <div className={`rounded-lg p-2 ${color}`}>
          <Icon className="h-4 w-4 text-white" />
        </div>
      </div>
    </div>
  );

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="mx-auto mb-3 h-12 w-12 animate-spin rounded-full border-b-2 border-blue-600"></div>
          <p className="text-sm text-gray-600">Loading analytics...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="rounded-lg border border-red-200 bg-white p-6 text-center shadow-sm">
          <p className="mb-2 text-sm text-red-600">Error loading data</p>
          <p className="text-xs text-gray-500">{error}</p>
          <button
            onClick={fetchData}
            className="mt-3 rounded-md bg-blue-600 px-4 py-2 text-xs text-white hover:bg-blue-700"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <p className="text-sm text-gray-600">No data available</p>
      </div>
    );
  }

  // Handle both single period and "all" period responses
  const stats = data.stats || {};
  const graphData = formatGraphData(data.graphData || []);

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="mx-auto max-w-7xl">
        {/* Header */}
        <div className="mb-4">
          <h1 className="mb-1 text-2xl font-bold text-gray-900">
            Analytics Dashboard
          </h1>
          <p className="text-xs text-gray-500">User statistics and insights</p>
        </div>

        {/* Period Selector */}
        <div className="mb-4 rounded-lg border border-gray-200 bg-white p-3 shadow-sm">
          <div className="flex flex-wrap items-center gap-2">
            <Calendar className="h-4 w-4 text-gray-400" />
            {periods.map((p) => (
              <button
                key={p.value}
                onClick={() => setPeriod(p.value)}
                className={`rounded-md px-3 py-1 text-xs font-medium transition-colors ${
                  period === p.value
                    ? "bg-blue-600 text-white"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }`}
              >
                {p.label}
              </button>
            ))}
          </div>

          {period === "custom" && (
            <div className="mt-3 flex items-center gap-2">
              <input
                type="date"
                value={customDates.start}
                onChange={(e) =>
                  setCustomDates({ ...customDates, start: e.target.value })
                }
                className="rounded-md border border-gray-300 px-2 py-1 text-xs"
              />
              <span className="text-xs text-gray-500">to</span>
              <input
                type="date"
                value={customDates.end}
                onChange={(e) =>
                  setCustomDates({ ...customDates, end: e.target.value })
                }
                className="rounded-md border border-gray-300 px-2 py-1 text-xs"
              />
              <button
                onClick={fetchData}
                className="rounded-md bg-blue-600 px-3 py-1 text-xs text-white hover:bg-blue-700"
              >
                Apply
              </button>
            </div>
          )}
        </div>

        {/* Debug Info */}
        {/* <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4">
          <p className="text-xs font-medium text-yellow-800 mb-1">Debug Info:</p>
          <p className="text-xs text-yellow-700">Period: {period}</p>
          <p className="text-xs text-yellow-700">Stats Keys: {Object.keys(stats).join(', ') || 'None'}</p>
          <p className="text-xs text-yellow-700">Graph Data Points: {graphData.length}</p>
          <p className="text-xs text-yellow-700 mt-2">Raw Response Structure:</p>
          <pre className="text-xs text-yellow-700 mt-1 overflow-auto max-h-32 bg-yellow-100 p-2 rounded">
            {JSON.stringify(data, null, 2)}
          </pre>
        </div> */}

        {/* Key Metrics */}
        {stats.totalUsers !== undefined && (
          <div className="mb-4 grid grid-cols-2 gap-3 md:grid-cols-4">
            <StatCard
              icon={Users}
              title="Total Users"
              value={stats.totalUsers}
              color="bg-blue-500"
            />
            {/* <StatCard icon={Image} title="With Profile Pic" value={stats.withProfilePic} color="bg-green-500" /> */}
            {/* <StatCard icon={FileText} title="With Prescriptions" value={stats.withPrescriptions} color="bg-orange-500" /> */}
            {/* <StatCard icon={UserCheck} title="With Patient Details" value={stats.withPatientDetails} color="bg-purple-500" /> */}
          </div>
        )}

        {/* Growth Chart */}
        {graphData.length > 0 && (
          <div className="mb-4 rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
            <div className="mb-3 flex items-center justify-between">
              <h2 className="text-sm font-semibold text-gray-900">
                User Growth Trend
              </h2>
              <TrendingUp className="h-4 w-4 text-blue-600" />
            </div>
            <ResponsiveContainer width="100%" height={200}>
              <LineChart data={graphData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                <XAxis
                  dataKey="date"
                  tick={{ fontSize: 10 }}
                  stroke="#9ca3af"
                />
                <YAxis tick={{ fontSize: 10 }} stroke="#9ca3af" />
                <Tooltip contentStyle={{ fontSize: 11, padding: 8 }} />
                <Line
                  type="monotone"
                  dataKey="count"
                  stroke="#3b82f6"
                  strokeWidth={2}
                  dot={{ r: 3 }}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        )}

        {/* Top Regions & Cities */}
        {stats.byRegion && stats.byCity && (
          <div className="mb-4 grid gap-4 md:grid-cols-2">
            <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
              <div className="mb-3 flex items-center gap-2">
                <MapPin className="h-4 w-4 text-gray-600" />
                <h2 className="text-sm font-semibold text-gray-900">
                  Top Regions
                </h2>
              </div>
              {stats.byRegion.length > 0 ? (
                <div className="space-y-2">
                  {stats.byRegion.slice(0, 8).map((region, idx) => (
                    <div
                      key={idx}
                      className="flex items-center justify-between"
                    >
                      <span className="text-xs text-gray-700">
                        {region._id || "Unknown"}
                      </span>
                      <div className="flex items-center gap-2">
                        <div className="h-1.5 w-24 rounded-full bg-gray-200">
                          <div
                            className="h-1.5 rounded-full bg-blue-600"
                            style={{
                              width: `${
                                (region.count / stats.byRegion[0].count) * 100
                              }%`,
                            }}
                          ></div>
                        </div>
                        <span className="w-10 text-right text-xs font-medium text-gray-900">
                          {region.count}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="py-4 text-center text-xs text-gray-500">
                  No region data
                </p>
              )}
            </div>

            <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
              <div className="mb-3 flex items-center gap-2">
                <MapPin className="h-4 w-4 text-gray-600" />
                <h2 className="text-sm font-semibold text-gray-900">
                  Top Cities
                </h2>
              </div>
              {stats.byCity.length > 0 ? (
                <div className="space-y-2">
                  {stats.byCity.slice(0, 8).map((city, idx) => (
                    <div
                      key={idx}
                      className="flex items-center justify-between"
                    >
                      <span className="text-xs text-gray-700">
                        {city._id || "Unknown"}
                      </span>
                      <div className="flex items-center gap-2">
                        <div className="h-1.5 w-24 rounded-full bg-gray-200">
                          <div
                            className="h-1.5 rounded-full bg-green-600"
                            style={{
                              width: `${
                                (city.count / stats.byCity[0].count) * 100
                              }%`,
                            }}
                          ></div>
                        </div>
                        <span className="w-10 text-right text-xs font-medium text-gray-900">
                          {city.count}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="py-4 text-center text-xs text-gray-500">
                  No city data
                </p>
              )}
            </div>
          </div>
        )}

        {/* Platform & User Type Distribution */}
        {stats.byPlatform && stats.byUserType && (
          <div className="mb-4 rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
            <div className="mb-3 flex items-center gap-2">
              <Monitor className="h-4 w-4 text-gray-600" />
              <h2 className="text-sm font-semibold text-gray-900">
                By Platform
              </h2>
            </div>
            {stats.byPlatform.length > 0 ? (
              <ResponsiveContainer width="100%" height={180}>
                <PieChart>
                  <Pie
                    data={stats.byPlatform}
                    dataKey="count"
                    nameKey="_id"
                    cx="50%"
                    cy="50%"
                    outerRadius={60}
                    label={(entry) => `${entry._id}: ${entry.count}`}
                    labelStyle={{ fontSize: 10 }}
                  >
                    {stats.byPlatform.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                  <Tooltip contentStyle={{ fontSize: 11, padding: 6 }} />
                </PieChart>
              </ResponsiveContainer>
            ) : (
              <p className="py-8 text-center text-xs text-gray-500">
                No platform data
              </p>
            )}
          </div>
        )}
        {/* App Versions */}
        {stats.byAppVersion && stats.byAppVersion.length > 0 && (
          <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
            <div className="mb-3 flex items-center gap-2">
              <Smartphone className="h-4 w-4 text-gray-600" />
              <h2 className="text-sm font-semibold text-gray-900">
                App Versions
              </h2>
            </div>
            <div className="grid gap-4 md:grid-cols-2">
              {stats.byAppVersion.map((platform, idx) => (
                <div key={idx}>
                  <h3 className="mb-2 text-xs font-medium uppercase text-gray-700">
                    {platform.platform}
                  </h3>
                  <div className="space-y-1.5">
                    {platform.versions
                      .sort((a, b) => b.count - a.count)
                      .slice(0, 6)
                      .map((v, i) => (
                        <div
                          key={i}
                          className="flex items-center justify-between text-xs"
                        >
                          <span className="text-gray-600">v{v.version}</span>
                          <span className="font-medium text-gray-900">
                            {v.count} users
                          </span>
                        </div>
                      ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
